
export default function Conditions() {
  const conditions = [
    {
      icon: 'ri-passport-line',
      title: 'Bằng lái xe quốc tế',
      description: 'Cần có bằng lái xe quốc tế hoặc bằng lái Mỹ để tham gia tour tự lái',
      color: 'from-blue-500 to-cyan-400'
    },
    {
      icon: 'ri-steering-2-line',
      title: 'Lái xe dễ dàng',
      description: 'Lái xe tại Hawaii rất dễ - Đường rộng - Ít xe - Có hỗ trợ nhóm trưởng 24/7',
      color: 'from-green-500 to-teal-400'
    },
    {
      icon: 'ri-map-pin-user-line',
      title: 'Tùy chọn linh hoạt',
      description: 'Chọn tour 2 đảo hoặc 3 đảo tùy theo thời gian và ngân sách của bạn',
      color: 'from-purple-500 to-pink-400'
    },
    {
      icon: 'ri-team-line',
      title: 'Nhóm 4-5 người/xe',
      description: 'Mỗi xe 7-8 chỗ sẽ có 4-5 khách để đảm bảo thoải mái trong suốt hành trình',
      color: 'from-orange-500 to-yellow-400'
    }
  ];

  const faqs = [
    {
      question: 'Tôi chưa có kinh nghiệm lái xe ở nước ngoài, có tham gia được không?',
      answer: 'Hoàn toàn được! Lái xe tại Hawaii rất dễ dàng với đường rộng, ít xe và luật giao thông đơn giản. Chúng tôi có nhóm trưởng dẫn đầu và hỗ trợ 24/7. Bạn sẽ được hướng dẫn chi tiết trước khi khởi hành.'
    },
    {
      question: 'Tôi có cần visa Mỹ không?',
      answer: 'Có, bạn cần visa du lịch Mỹ (B1/B2). Chúng tôi sẽ hỗ trợ tư vấn hồ sơ và chuẩn bị phỏng vấn visa hoàn toàn miễn phí cho khách đăng ký tour.'
    },
    {
      question: 'Chi phí xăng xe và phí đường khoảng bao nhiêu?',
      answer: 'Chi phí xăng ước tính khoảng $150-200/xe cho toàn bộ hành trình (chia cho 4-5 người). Phí cầu đường và parking khoảng $50-80/xe. Tổng chi phí phụ khoảng $50-60/người.'
    },
    {
      question: 'Tôi nên chọn tour 2 đảo hay 3 đảo?',
      answer: 'Tour 2 đảo phù hợp nếu bạn có thời gian hạn chế (6 ngày). Tour 3 đảo (9-10 ngày) cho phép bạn khám phá đầy đủ hơn với Maui và cung đường Hana tuyệt đẹp. Cả 2 tour đều rất đáng giá!'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Điều kiện & <span className="text-blue-600">Lưu ý</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Những thông tin quan trọng bạn cần biết trước khi tham gia
          </p>
        </div>

        {/* Conditions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {conditions.map((condition, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-14 h-14 bg-gradient-to-r ${condition.color} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`${condition.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{condition.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{condition.description}</p>
            </div>
          ))}
        </div>

        {/* FAQs */}
        <div className="bg-white rounded-3xl p-8 sm:p-12 shadow-xl">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">Câu hỏi thường gặp</h3>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-gradient-to-r from-blue-50 to-teal-50 rounded-2xl p-6 border-l-4 border-blue-600"
              >
                <h4 className="text-lg font-bold text-gray-900 mb-3 flex items-start">
                  <i className="ri-question-line text-blue-600 text-xl mr-2 flex-shrink-0 mt-1"></i>
                  {faq.question}
                </h4>
                <p className="text-gray-700 leading-relaxed pl-7">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#final-cta"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-teal-500 text-white rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Kiểm tra điều kiện tham gia
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
